// Modules
import { connect } from 'react-redux';
import React from 'react';
import _ from 'lodash';

import { Page, PageHeader, Tabs, Tab } from 'components/page';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';

import * as actions from './store/actions';

function ViewCompany({ id, children, currentUser }) {
  const { data: company } = actions.useCompany(id);
  const isLead = Person.isLead(currentUser);

  if (!company) return null;

  const clonedChildren = React.cloneElement(children, {
    load: _.noop,
    update: _.noop,
    currentUser,
    id
  });

  return (
    <Page className="company-page">
      <PageHeader title={company.name}>
        <Tabs className="actions-tabs">
          <Tab to={`/companies/${id}/summary`}>
            <SVG src="svg/company.svg" className="company" />
            <span>Summary</span>
          </Tab>
          <Tab to={`/companies/${id}/people`}>
            <SVG src="svg/person.svg" className="person" />
            <span>People</span>
          </Tab>
          { isLead &&
            <Tab to={`/companies/${id}/agreements`}>
              <SVG src="svg/agreement.svg" className="agreement" />
              <span>Agreements</span>
            </Tab>
          }
          { isLead &&
            <Tab to={`/companies/${id}/work-orders`}>
              <SVG src="svg/invoice-list.svg" className="work-order" />
              <span>Work Orders</span>
            </Tab>
          }
          { isLead &&
            <Tab to={`/companies/${id}/watches`}>
              <SVG src="svg/growth.svg" className="growth" />
              <span>Watches</span>
            </Tab>
          }
          <Tab to={`/companies/${id}/forms`}>
            <SVG src="svg/checklist.svg" className="form-icon" />
            <span>Forms</span>
          </Tab>
        </Tabs>
      </PageHeader>
      {clonedChildren}
    </Page>
  );
}

export default connect((state, ownProps) => ({
  currentUser: state.auth.currentUser,
  id: ownProps.routeParams.companyId
}))(ViewCompany);


// Component
// class ViewCompanyOld extends React.Component {
  // static propTypes = {
  //   companyId: PropTypes.string,
  //   currentUser: PropTypes.object,
  //   company: PropTypes.object,
  //   children: PropTypes.node,
  //   fetching: PropTypes.bool
  // };

  // static defaultProps = {
  //   company: {}
  // };

  // constructor(props) {
  //   super(props);

  //   this.loadCompany = this.loadCompany.bind(this);
  //   this.updateCompany = this.updateCompany.bind(this);
  // }

  // componentDidMount() {
  //   this.loadCompany();
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.companyId !== this.props.companyId) this.loadCompany(nextProps.companyId);
  // }

  // componentWillUnmount() {
  //   actions.set({ company: null });
  // }

  // loadCompany(passedId) {
  //   const id = passedId || this.props.companyId;
  //   actions.set({ fetching: true });

    // const load = [
    //   'emailAddresses.billingCompanies',
    //   'phoneNumbers',
    //   'addresses',
    //   'billingEmails.contact',
    //   'defaultAgreement',
    //   'team',
    //   'primaryTech'
    // ];

  //   return Company.findOne(id, { load })
  //     .then(company => {
  //       actions.set({ fetching: false, company });

  //       const personWhere = {
  //         company: id,
  //         status: { in: ['Disabled', 'Active'] }
  //       };

  //       return Promise.all([
  //         Agreement.find({ where: { company: id } }),
  //         Person.find({ where: personWhere, load: ['primaryEmail', 'phoneNumbers', 'emailAddresses'] }),
  //         Form.find(_.defaults({ where: { company: id } }, Form.defaultQuery)),
  //         Watch.find({ where: { company: id } })
  //       ]);
  //     })
  //     .then(([agreements, people, forms, watches]) => {
  //       actions.set({ agreements, people, forms, watches });
  //     });
  // }

  // updateCompany(updates) {
  //   const { company } = this.props;
  //   actions.set({ company: _.assign({}, company, updates) });

  //   return Company.update(_.assign({ id: company.id }, updates));
  // }

  // render() {
  //   const { company, companyId, children, currentUser } = this.props;
  //   const isLead = Person.isLead(currentUser);
  //   const clonedChildren = React.cloneElement(children, {
  //     load: this.loadCompany,
  //     update: this.updateCompany
  //   });

  //   return null;

  //   if (!company || _.isEmpty(company)) return null;

  //   return (
  //     <Page className="company-page">
  //       <PageHeader title={company.name}>
  //         <Tabs className="actions-tabs">
  //           <Tab to={`/companies/${companyId}/summary`}>
  //             <SVG src="svg/company.svg" className="company" />
  //             <span>Summary</span>
  //           </Tab>
  //           <Tab to={`/companies/${companyId}/people`}>
  //             <SVG src="svg/person.svg" className="person" />
  //             <span>People</span>
  //           </Tab>
  //           { isLead &&
  //             <Tab to={`/companies/${companyId}/agreements`}>
  //               <SVG src="svg/agreement.svg" className="agreement" />
  //               <span>Agreements</span>
  //             </Tab>
  //           }
  //           { isLead &&
  //             <Tab to={`/companies/${companyId}/watches`}>
  //               <SVG src="svg/growth.svg" className="growth" />
  //               <span>Watches</span>
  //             </Tab>
  //           }
  //           <Tab to={`/companies/${company.id}/forms`}>
  //             <SVG src="svg/checklist.svg" className="form-icon" />
  //             <span>Forms</span>
  //           </Tab>
  //         </Tabs>
  //       </PageHeader>
  //       {clonedChildren}
  //     </Page>
  //   );
  // }
// }



// WEBPACK FOOTER //
// ./app/routes/company/view-company.js